<template>
  <div class="work-item-edit">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>作業項目</span>
          </li>
        </ul>
      </div>
    </div>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="section">
        <div class="container">
          <dl class="columns">
            <dt>名称</dt>
            <dd>
              <ValidationProvider
                rules="required|max:100"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="editData.season_name" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>作業区分</dt>
            <dd v-if="viewMode === 'e'">
              <label v-if="editData.is_not_paddy_field_item">ほ場外作業</label>
              <label v-else>ほ場作業</label>
            </dd>
            <dd v-else>
              <input
                id="box1"
                type="checkbox"
                v-model="editData.is_not_paddy_field_item"
              />
              <label for="box1">ほ場外作業</label>
            </dd>
          </dl>
          <dl class="columns">
            <dt>色</dt>
            <dd>
              <div
                v-for="(row, index) in colors"
                :key="index"
                class="color-radio-button"
                :style="{
                  background: row === editData.color ? '#ddd' : '',
                }"
              >
                <label>
                  <input
                    type="radio"
                    name="user_color"
                    :value="row"
                    v-model="editData.color"
                  />
                  <div
                    :style="{
                      background: row,
                    }"
                  ></div>
                </label>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <div id="button-area">
        <div class="left-box" />
        <div class="center-box">
          <span
            v-if="viewMode === 'e'"
            class="btn btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid || isReadOnly,
            }"
            @click="onSubmitWorkItemEdit"
            >保存</span
          >
          <span
            v-else
            class="btn btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid || isReadOnly,
            }"
            @click="onSubmitWorkItemAdd"
            >登録</span
          >
          <span class="btn btn-cancel" @click="onCancel">キャンセル</span>
        </div>
        <div class="right-box">
          <span
            v-if="viewMode === 'e'"
            class="text"
            :class="{ active: !isReadOnly, disabled: isReadOnly }"
            @click="onSubmitWorkItemDelete"
            >削除</span
          >
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import Dialog from "@/mixins/dialog";

export default {
  components: {},
  mixins: [Loader, Dialog],

  props: {
    viewMode: {
      type: String,
      default: "a",
    },
    viewData: {
      type: Object,
    },
  },

  data() {
    return {
      editData: {
        season_name: "",
        season_id: "",
        is_not_paddy_field_item: false,
        color: null,
      },
      colors: [
        "#1A82B7",
        "#3EC08D",
        "#008A5B",
        "#B4AF4F",
        "#7D7A1A",
        "#F98E71",
        "#BC5A40",
        "#FF859F",
        "#C499F0",
        "#8D65B8",
      ],
      isReadOnly: false,
    };
  },
  mounted: function () {
    this.isReadOnly = this.isPastManagement();
    if (this.viewMode === "e") {
      this.editData.season_id = this.viewData.season_id;
      this.editData.season_name = this.viewData.season_name;
      this.editData.is_not_paddy_field_item =
        this.viewData.is_not_paddy_field_item;
      if (this.viewData.color) {
        this.editData.color = this.viewData.color;
      } else {
        this.editData.color = this.colors[0];
      }
    } else {
      this.editData.color = this.colors[0];
    }
  },

  methods: {
    ...mapActions(["insertSeasons", "updateSeasons", "deleteSeasons"]),
    ...mapGetters(["isPastManagement"]),

    async onSubmitWorkItemAdd() {
      await this.insertSeasons(this.editData);
      this.$router.push({ name: "works" });
    },
    async onSubmitWorkItemEdit() {
      await this.updateSeasons(this.editData);
      this.$router.push({ name: "works" });
    },
    async onSubmitWorkItemDelete() {
      this.showConfirm("削除しますか？", async () => {
        this.loading(async () => {
          await this.deleteSeasons(this.editData.season_id);
          this.$router.push({ name: "works" });
        });
      });
    },
    onCancel: function () {
      this.$router.push({ name: "works" });
    },
  },
};
</script>

<style lang="scss">
.work-item-edit {
  .section {
    overflow: auto;
    width: 50%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      /* フォーム */

      input[type="text"],
      input[type="date"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="date"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }

      .color-radio-button {
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 10px;
        margin: 2px;
        float: left;
      }
      .color-radio-button:hover {
        background: #eee;
      }
      .color-radio-button div {
        height: 36px;
        width: 36px;
        border-radius: 50%;
      }
      .color-radio-button label {
        cursor: pointer;
      }
    }
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 0px auto 40px;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text.disabled {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_style.svg") no-repeat center center;
  }
}
</style>
